import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import Loader from '../components/Loader';
import GuideSidebar from '../components/GuideSidebar';

const AccelerateProgram = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [blog, setBlog] = useState(null);
    const [faq, setFaq] = useState([]);

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');

            if (!hostData || !hostData.host_access_token) {
                setError(new Error('Host authentication information not found.'));
                setLoading(false);
                return;
            }

            const formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    url: `${params.baseURL}${params.endpoints.getMyCalendar}`,
                    data: formData,
                });

                if (
                    response.data.items &&
                    Array.isArray(response.data.items)
                ) {
                    setListings(response.data.items);
                } else {
                    setError(
                        new Error('An error occurred while fetching listings.')
                    );
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        const fetchBlogData = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');

            if (!hostData || !hostData.host_access_token) {
                return;
            }

            const formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('page_id', 'my-calendar');

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    url: `${params.baseURL}${params.endpoints.blogData}`,
                    data: formData,
                });

                if (response.data.status === 'ok') {
                    setBlog(response.data.list?.blog || null);
                    setFaq(response.data.list?.faqs || []);
                } else {
                    console.log(
                        'An error occurred while fetching blog data.'
                    );
                }
            } catch (err) {
                console.log(err.message);
            }
        };

        fetchListings();
        fetchBlogData();
    }, []);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return (
            <div className="accelerate-error">
                <p>Error loading listings: {error.message}</p>
            </div>
        );
    }

    return (
        <div className="accelerate-page">

            <Helmet>
                <title>Accelerate Your Program</title>
                <meta
                    name="description"
                    content=""
                />
            </Helmet>

            <div className="row">

                {/* =========================================
                    LEFT CONTENT
                ========================================= */}
                <div className="col-md-8">

                    {/* PAGE TITLE */}
                    <div className='yl-header p-0'>
                        <div className='img-title-box'>
                            <img src={'/assets/img/title/accelerate_title_2.png'} className='img-fluid img-title' style={{'width' : '100%', 'height' : '100%'}} alt='' />
                        </div>
                    </div>


                    {/* =========================================
                        LISTINGS
                    ========================================= */}
                    {listings.length > 0 ? (

                        <div className="row accelerate-listings">

                            {listings.map((listing, index) => {

                                const coverImage =
                                    listing.cover_photo ||
                                    '/assets/img/default_listing.jpg';

                                const categoryImage =
                                    listing.category_info?.category_image_url ||
                                    '/assets/img/default_listing.jpg';

                                return (
                                    <div
                                        className="col-md-6 lb"
                                        key={
                                            listing.stay_listing_id ||
                                            index
                                        }
                                    >

                                        <a
                                            href={`/accelerate-listing/${listing.stay_listing_id}`}
                                            className="accelerate-link"
                                        >

                                            <div className="acc-box">

                                                {/* =========================================
                                                    IMAGE SECTION
                                                ========================================= */}
                                                <div className="apimgcibox">

                                                    {/* PROPERTY COVER IMAGE */}
                                                    <div className="image-wrapper lcibox">

                                                        <div className="ac-cover-image">

                                                            <img
                                                                src={coverImage}
                                                                className="ciso ap-ciso"
                                                                alt={
                                                                    listing.listing_title ||
                                                                    'Untitled Listing'
                                                                }
                                                            />

                                                        </div>

                                                    </div>


                                                    {/* CATEGORY IMAGE */}
                                                    <div className="logo-wrapper">

                                                        <img
                                                            src={categoryImage}
                                                            className="cist"
                                                            alt=""
                                                        />

                                                    </div>

                                                </div>


                                                {/* =========================================
                                                    LISTING INFORMATION
                                                ========================================= */}
                                                <div className="pltxt-box">

                                                    <div className="cat-pointer mb-0">

                                                        {listing.property_title_icon_image && (
                                                            <img
                                                                src={
                                                                    listing.property_title_icon_image
                                                                }
                                                                alt="Profile"
                                                                className="pointer-icon"
                                                            />
                                                        )}

                                                        <div className="wspl-ta-section">

                                                            <span className="wspl-title-box">
                                                                {
                                                                    listing.listing_title ||
                                                                    'Unknown Title'
                                                                }
                                                            </span>

                                                            <span className="wspl-add-box">
                                                                {
                                                                    listing.property_address ||
                                                                    ''
                                                                }
                                                            </span>

                                                        </div>

                                                    </div>

                                                </div>


                                                {/* =========================================
                                                    ACCELERATE BUTTON
                                                ========================================= */}
                                                <div className="co-host-box">

                                                    <span className="acc-btn-txt">
                                                        Accelerate
                                                    </span>

                                                </div>

                                            </div>

                                        </a>

                                    </div>
                                );
                            })}

                        </div>

                    ) : (

                        <div className="no-listings">
                            <p>No active listings found</p>
                        </div>

                    )}

                </div>


                {/* =========================================
                    RIGHT SIDEBAR
                ========================================= */}
                <div className="col-md-4 p-0">

                    <GuideSidebar
                        slug="accelerate-program"
                    />

                </div>

            </div>

        </div>
    );
};

export default AccelerateProgram;